class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();
    mm.add("(min-width: 768px)", () => {
      gsap.utils.toArray(".js-img").forEach((target) => {  
        gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: "top 70%",
            end: "bottom center",
            // toggleActions: "play none none reverse",
            // markers: true,
          }
        })
        .fromTo(target,{
          opacity: 0,
          yPercent: 15,
        },
        {
          opacity: 1,
          yPercent: 0,
        })
        gsap.fromTo(target.querySelector('img'), {
          yPercent: 0,
        }, {
          yPercent: -30,
          scrollTrigger: {
            trigger: target,
            start: "top center",
            end: "bottom center",
            scrub: true,
          }
        }); 
      });

      // const scrollLine = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: ".js-target",
      //     start: "top 30%",
      //     end: "bottom bottom",
      //     scrub: true, 
      //   },
      // });
      const tl = gsap.timeline(
        {
          scrollTrigger: {
            trigger: ".js-trigger",
            start: "top 70%",
            end: "bottom bottom",
            // markers: true,
          }
        }
      );
      tl.to('.js-x-line', { width: '100%', duration: 1.3, })
      .to('.js-y-line', { height: '100%', duration: 1.3, },'>');

    });
    mm.add("(max-width: 767px)", () => {
      gsap.utils.toArray(".js-img").forEach((target) => {  
        gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: "top 70%",
            end: "bottom center",
            // toggleActions: "play none none reverse",
            // markers: true,
          }
        })
        .fromTo(target,{
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
        })
        gsap.fromTo(target.querySelector('img'), {
          y: 0,
        }, {
          y: -5,
          scrollTrigger: {
            trigger: target,
            start: "top center",
            end: "bottom center",
            scrub: true,
          }
        }); 
      });  
    });


    const items = gsap.utils.toArray(".js-parallax-img");

    items.forEach((item) => {
      gsap.fromTo(
        item.querySelector("img"), // アニメーションを適用する画像要素を取得
        {
          yPercent: 0, // パララックス前の要素の位置
        },
        {
          yPercent: -20, // 上に要素の幅の1/5分移動
          ease: "none", // イージングなし
          scrollTrigger: {
            trigger: item, // アニメーションのトリガー要素
            start: "top bottom", // アニメーション開始位置
            end: "bottom top", // アニメーション終了位置
            scrub: 1, // 動作を遅らせる
          },
        }
      );
    });

    gsap.utils.toArray(".js-text").forEach((target) => {  
      gsap.timeline({
        scrollTrigger: {
          trigger: target,
          start: "top 50%",
          end: "bottom center",
          // toggleActions: "play none none reverse",
          // markers: true,
        }
      })
      .fromTo(target,{
        opacity: 0,
        yPercent: 10,
      },
      {
        opacity: 1,
        yPercent: 0,
      })
    });
  }
}